import { QuotationTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1600. 見積タスクコメント登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/quotation_task_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  content: string;
  content_json: string;
  parent_id?: number;
};

const createQuotationTaskComment = (props: Props): Promise<QuotationTaskComment> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/quotation_task_comments`,
    props
  );
};

export const useCreateQuotationTaskComment = () => {
  return useMutation({
    mutationFn: createQuotationTaskComment
  });
};
